import { AgentDetails } from '@zet/utils/interface'
import { create } from 'zustand'

import { PaymentModes } from '@zet/utils/interface'

type Store = {
  user: AgentDetails | null
  setUser: (agent: AgentDetails | null) => void
  paymentModes: PaymentModes | null
  setPaymentModes: (payload: PaymentModes) => void
  flags: string[] | string | null
  setFlags: (payload: string) => void
}

const useStore = create<Store>((set) => ({
  user: null,
  paymentModes: null,
  setUser: (agent) => set((state) => ({ ...state, user: agent })),
  setPaymentModes: (payload) =>
    set((state) => ({ ...state, paymentModes: payload })),
  flags: null,
  setFlags: (payload) => set((state) => ({ ...state, flags: payload })),
}))

export default useStore
